import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import {
  EEntityType,
  ETicketCategorySubMenuAction,
  ISubMenuItem,
  ITicketCategory,
} from '@web/dtos';
import { HoverHighlight } from '../../../directives/hover-highlight';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-ticket-category-sub-menu',
  imports: [HoverHighlight],
  templateUrl: './ticket-category-sub-menu.component.html',
})
export class TicketCategorySubMenuComponent {
  public readonly ticketCategory: InputSignal<ITicketCategory> =
    input.required();
  public readonly onSubmenuClick: OutputEmitterRef<ETicketCategorySubMenuAction> =
    output();

  protected readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly cmsTextProviderService: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  protected readonly highlightedItem: WritableSignal<number | undefined> =
    signal(undefined);
  protected readonly isDarkMode: Signal<boolean> =
    this.corporateDesign.isDarkModeActive;
  public readonly darkModeColor: string =
    this.corporateDesignStore.corporateDesign().colorAdmixtures.dark_surface_01;
  public subMenuItems: ISubMenuItem[] = [
    {
      text: this.cmsTextProviderService.ticketCategories.switchToRight,
      action: ETicketCategorySubMenuAction.switchToRight,
    },
    {
      text: this.cmsTextProviderService.ticketCategories.switchToLeft,
      action: ETicketCategorySubMenuAction.switchToLeft,
    },
    {
      text: this.cmsTextProviderService.ticketCategories.rename,
      action: ETicketCategorySubMenuAction.rename,
    },
    {
      text: this.cmsTextProviderService.shared.delete,
      action: ETicketCategorySubMenuAction.delete,
    },
  ];

  protected readonly EEntityType: typeof EEntityType = EEntityType;

  public setHighlightedItem(isHovered: boolean, index: number): void {
    if (isHovered) {
      this.highlightedItem.set(index);
    }
  }
}
